/* global __firebase_config, __app_id */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// Global Firebase Init with Environment Variables and global fallback
const firebaseConfig = typeof __firebase_config !== 'undefined' 
  ? JSON.parse(__firebase_config) 
  : {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCpGLdTVK3fkUUzsjK6704pdAceiiM5fS0",
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "lawfirmdb-7a3da.firebaseapp.com",
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "lawfirmdb-7a3da",
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "lawfirmdb-7a3da.firebasestorage.app",
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "808421508613",
      appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:808421508613:web:a5b56d33d3793123e2fe6c"
    };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const appId = typeof __app_id !== 'undefined' ? __app_id : 'law-firm-system';
